export const generateChartOptions = (
  chartData,
  selectedAttributeNamesByDimension,
  chartType,
  chartTitle,
  chartSubtitle,
  scale = 1.3,
  customTooltip = {} ) => {
  const baseHeight = 400; 
  return {
    offlineExporting: { enabled: true },
    chart: {
      type: chartType,
      exportEnabled: true,
      height: baseHeight * scale,
    },
    exporting: { enabled: false },
    title: {
      text: chartTitle,
      align: 'left',
      style: {
        color: '#000000',
        textOutline: '0px contrast',
        fontSize: `20px`,
        fontWeight: 'normal',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
      },
    },
    subtitle: {
      text: chartSubtitle,
      align: 'left',
      style: {
        color: 'rgb(117, 117, 117)',
        textOutline: '0px contrast',
        fontSize: `14px`,
        whiteSpace: 'normal',
        wordWrap: 'break-word',
      },
    },
    xAxis: {
      categories: chartData.xAttributes.map((item) => item.name),
      gridLineWidth: 0,
    },
    yAxis: {
      min: 0,
      gridLineWidth: 0,
      title: { text: null },
      labels: { enabled: false },
      stackLabels: { enabled: true, style: { fontWeight: 'bold' } },
    },
    credits: { enabled: false },
    colors: [
      '#cce1ff', '#108980', '#2251ff','#ffdca6', '#5e9dff',
      '#99c4ff', '#eb9b00', '#0e2b99', '#061f79', '#ccf2ff', 
      '#6ecbf7', '#0863aa', '#386694', '#cccccc', '#656565',
      '#ad2e93', '#a3f5ef', '#0bdacb', '#12a195', '#e6d7bc',
      '#f9d8c5', '#c69e87', '#f7baf6', '#82a6c9', '#f5ead6',
      '#daa872', '#c9a167', '#faa8a8', '#cc49c2', '#ffcd75',
      '#ffe4b3'
    ],
    legend: {
      align: 'left',
      alignColumns: true,
      x: 7,
      verticalAlign: 'top',
      y: 10,
      floating: false,
      borderWidth: 0,
      symbolRadius: 0,
    },
    tooltip: customTooltip,
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: { enabled: true, style: { fontWeight: 'normal' } },
      },
      line: {
        dataLabels: {
          enabled: true,
          style: {
            fontWeight: 'normal',
            fontSize: `12px`,
            color: '#000000',
            textOutline: 'none',
          },
        },
      },
    },
    series: chartData.yAttributes.map((yAttribute) => {
      return {
        name: yAttribute.name,
        data: chartData.dataPoints
          .filter((point) => point.yAttributeId === yAttribute.attributeId)
          .map(point => point.value > 0 ? point.value : null),
      };
    }),
  };
};